var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHealthPilatesServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 90,
    viewBox: "0 0 93 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2141_371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.4799 19.3721C80.011 19.3721 80.5224 19.5418 80.9167 19.8976C83.1953 21.9538 90.9941 30.0916 90.9941 45.156C90.9941 60.2204 83.1953 68.3582 80.9167 70.4143C80.5224 70.7701 80.011 70.9399 79.4799 70.9399H74.9508H65.0297C64.5259 70.9399 64.0378 70.7858 63.6446 70.471C61.0268 68.3747 50.8858 59.3387 50.8858 45.156C50.8858 30.9733 61.0268 21.9373 63.6446 19.841C64.0378 19.5261 64.5259 19.3721 65.0297 19.3721H74.9508H79.4799Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.1209,
    cy: 45.156,
    rx: 25.7839,
    ry: 14.3244,
    transform: "rotate(90 65.1209 45.156)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.526 19.377C75.526 19.377 85.8359 27.5163 85.8359 45.1517C85.8359 62.787 75.526 70.9264 75.526 70.9264H67.7936C67.7936 70.9264 78.1035 61.4305 78.1035 45.1517C78.1035 28.8729 67.7936 19.377 67.7936 19.377H75.526Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1707 37.4072C64.1707 37.4072 68.5117 39.849 68.5117 45.1396C68.5117 50.4303 64.1707 52.8721 64.1707 52.8721H25.3729C25.3729 52.8721 22.1172 50.0233 22.1172 45.1396C22.1172 40.256 25.3729 37.4072 25.3729 37.4072H64.1707Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7768 19.3721C31.3079 19.3721 31.8193 19.5418 32.2136 19.8976C34.4922 21.9538 42.291 30.0916 42.291 45.156C42.291 60.2204 34.4922 68.3582 32.2136 70.4143C31.8193 70.7701 31.3079 70.9399 30.7768 70.9399H16.3266C15.8228 70.9399 15.3347 70.7858 14.9415 70.471C12.3237 68.3747 2.18272 59.3387 2.18272 45.156C2.18272 30.9733 12.3237 21.9373 14.9415 19.841C15.3347 19.5261 15.8228 19.3721 16.3266 19.3721H30.7768Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.328,
    cy: 45.156,
    rx: 25.7839,
    ry: 14.3244,
    transform: "rotate(90 16.328 45.156)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2354 34.8408C18.2354 34.8408 22.1016 38.0966 22.1016 45.1507C22.1016 52.2049 18.2354 55.4606 18.2354 55.4606H11.7917L9.21419 52.5149C9.21419 52.5149 9.21419 51.6622 9.21419 45.1507C9.21419 38.6392 9.21419 37.7865 9.21419 37.7865L11.7917 34.8408H18.2354Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2526 19.377C27.2526 19.377 37.5625 27.5163 37.5625 45.1517C37.5625 62.787 27.2526 70.9264 27.2526 70.9264H19.5202C19.5202 70.9264 29.8301 61.4305 29.8301 45.1517C29.8301 28.8729 19.5202 19.377 19.5202 19.377H27.2526Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.806,
    cy: 45.137,
    rx: 10.3099,
    ry: 5.15495,
    transform: "rotate(90 11.806 45.137)",
    fill: "#B8B8B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2141_371",
    x: 0.385902,
    y: 0.661133,
    width: 92.2262,
    height: 92.2262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.618
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.809002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2141_371"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2141_371",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHealthPilatesServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcHealthPilatesServiceMainMobile.85fd82ff2c19d192d6d9a5282a144016.svg";
export { ForwardRef as ReactComponent };